import React from 'react'

import { formatCurrency } from 'utils/formatCurrency'

import { ReserveCalloutText } from './DecisionResult.styled'

export default function DecisionResultReserveCallout({
    amount,
}: {
    readonly amount: number
}): JSX.Element | null {
    if (!amount) return null

    return (
        <ReserveCalloutText data-testid="DecisionResultReserveCallout">
            <strong>{formatCurrency(amount)}</strong> Reserve Eligible
        </ReserveCalloutText>
    )
}
